const firebaseConfig = {
  apiKey: "AIzaSyAqnlt0jxBL55B1obKqx8T3zzmBAbQ9NGE",
  authDomain: "shatterproof-application.firebaseapp.com",
  projectId: "shatterproof-application",
  storageBucket: "shatterproof-application.appspot.com",
  messagingSenderId: "1060392587752",
  appId: "1:1060392587752:web:81cd25186316c75cadd45d",
}

export default firebaseConfig
